import {
  ActivityIndicator,
  Dimensions,
  FlatList,
  PixelRatio,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const MeezaCreditTransactionHistory = () => {
  const [creditTransactData, setCreditTransactData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    getMeezaCreditTransactions();
  }, []);

  const getMeezaCreditTransactions = async () => {
    setIsLoading(true);
    try {
      // Make the axios POST request to the backend
      const response = await axiosPrivate.get("/getCreditTransfers/getCreditTransfers");

      // Handle success response
      if (response.status === 200 || response.status === 201) {
        //console.log('credit TransactionLists:', response.data.transactions);

        setCreditTransactData(response.data.transactions);

        // Toast.show({
        //     type: 'success',
        //     text1: 'Success',
        //     text2: response.data.message,
        // })

        // Use response.data.customerId if needed for further processing
      } else {
        //console.error('Unexpected response:', response);
        Toast.show({
          type: "error",
          text1: "Error",
          text2: "Unexpected response",
        });
      }
    } catch (error) {
      if (error.response) {
        // //console.error('Error response from server:', error.response.data);
        Toast.show({
          type: "error",
          text1: "Error",
          text2: error.response.data.message,
        });
      } else if (error.request) {
        //console.error('No response received:', error.request);
        Toast.show({
          type: "error",
          text1: "Error",
          text2: "No response received",
        });
      } else {
        //console.error('Error setting up the request:', error.message);
        Toast.show({
          type: "error",
          text1: "Error",
          text2: error.message,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (isoString) => {
    if (!isoString) return ""; // Handle empty or undefined input

    const date = new Date(isoString);

    if (isNaN(date)) return ""; // Handle invalid dates

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" }); // Use short month name (e.g., Jun)
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure 2-digit minutes
    const period = hours >= 12 ? "PM" : "AM"; // AM/PM format
    const formattedHour = hours % 12 || 12; // Convert to 12-hour format

    // Function to add suffix (st, nd, rd, th) to the day
    const getDayWithSuffix = (day) => {
      if (day > 3 && day < 21) return `${day}th`; // Special case for 11-13
      switch (day % 10) {
        case 1:
          return `${day}st`;
        case 2:
          return `${day}nd`;
        case 3:
          return `${day}rd`;
        default:
          return `${day}th`;
      }
    };

    return {
      date: `${getDayWithSuffix(day)} ${month} ${year}`,
      time: `${formattedHour}:${minutes} ${period}`,
    };
  };

  if (isLoading) {
    return (
      <View style={{ flex: 1 }}>
        <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
      </View>
    );
  }

  return (
    <View>
      {creditTransactData.length > 0 ? (
        <View style={styles.bodyContainer}>
          <View style={styles.giverHeaders}>
            <Text
              style={{
                paddingBottom: dynamicSpacing(10),
                fontSize: dynamicFontSize(12),
                color: Colours.PRIMARY,
                fontFamily: "Sen-Regular",
              }}
            >
              TRANSACTION HISTORY
            </Text>
          </View>
          <FlatList
            data={creditTransactData}
            scrollEnabled={false}
            keyExtractor={(history) => history._id}
            renderItem={({ item: history }) => (
              <TouchableOpacity style={styles.tablesListContainer2} onPress={() => {}}>
                <View style={styles.profileContainer}>
                  <View style={styles.profileSubContainer}>
                    {/* <Image source={{ uri: pulls?.userID?.profilePicture }} style={styles.userImage} /> */}
                    {/* // <Image source={require('../../../assets/imagePlaceholder.jpg')} style={styles.userImage} />} */}
                    {/* <Text style={{ fontSize: 12, color: Colours.DARKLIGHTGRAY, fontFamily: 'Sen-Regular' }} >BY: {pulls?.creatorName}</Text> */}
                    {/* <Text style={{ fontSize: 12, color: Colours.DARKLIGHTGRAY, fontFamily: 'Sen-Regular' }} >BY: {history?.userID?.firstname} {history?.userID?.lastname}</Text> */}
                    <Text
                      style={{
                        fontSize: dynamicFontSize(12),
                        color: Colours.DARKLIGHTGRAY,
                        fontFamily: "Sen-Regular",
                      }}
                    >
                      FROM: {history.transactionFrom}{" "}
                    </Text>
                    <Text
                      style={{
                        fontSize: dynamicFontSize(12),
                        color: Colours.DARKGRAY,
                        fontFamily: "Sen-Regular",
                      }}
                    >
                      TO: {history?.transactionTo}
                    </Text>
                  </View>
                  <View>
                    {/* <Text style={{ fontSize: 11, color: Colours.DARKLIGHTGRAY, fontFamily: 'Sen-Regular' }} >25th June 2021</Text>
                                        <Text style={{ fontSize: 10, color: Colours.PRIMARY, fontFamily: 'Sen-Regular', textAlign: 'right' }} >2:40pm</Text> */}
                    <Text
                      style={{
                        fontSize: dynamicFontSize(11),
                        color: Colours.DARKLIGHTGRAY,
                        fontFamily: "Sen-Regular",
                      }}
                    >
                      {formatDate(history?.createdAt).date}
                    </Text>
                    <Text
                      style={{
                        fontSize: dynamicFontSize(10),
                        color: Colours.PRIMARY,
                        fontFamily: "Sen-Regular",
                        textAlign: "right",
                      }}
                    >
                      {formatDate(history?.createdAt).time}
                    </Text>
                  </View>
                </View>

                <View style={styles.tableListTitlesContain}>
                  <View style={{ display: "flex", gap: dynamicSpacing(4) }}>
                    <Text
                      style={{
                        color: Colours.DARKGRAY,
                        fontSize: dynamicFontSize(15),
                        fontFamily: "Sen-Bold",
                        width: dynamicSize(200),
                      }}
                    >
                      Amount
                      <Text style={{ color: Colours.PRIMARY, fontFamily: "Sen-Bold" }}>
                        {" "}
                        ₦{history?.amount.toLocaleString()}
                      </Text>
                    </Text>
                    <Text
                      style={{
                        color: Colours.PRIMARY,
                        fontSize: dynamicFontSize(12),
                        fontFamily: "Sen-Regular",
                        width: dynamicSize(200),
                      }}
                    >
                      {history?.reason}
                    </Text>
                    <View style={styles.tableValueContainer}>
                      <View style={styles.pullValueContainer}>
                        {/* <Text style={{ color: Colours.DARKLIGHTGRAY, fontSize: 12, fontFamily: 'Sen-Regular' }}>Bal:</Text>
                                                <Text style={{ color: Colours.PRIMARY, fontFamily: 'Sen-Bold' }}>  ₦{Number(history?.walletNewBalance)?.toLocaleString()}</Text> */}
                        <Text
                          style={{
                            fontSize: dynamicFontSize(12),
                            color: Colours.DARKLIGHTGRAY,
                            fontFamily: "Sen-Regular",
                          }}
                        >
                          {history?.transactionType}{" "}
                        </Text>
                        <Text
                          style={{
                            fontSize: dynamicFontSize(12),
                            color: Colours.DARKLIGHTGRAY,
                            fontFamily: "Sen-Regular",
                          }}
                        >
                          {history?.transactionTag}
                        </Text>
                      </View>
                      <Text
                        style={{
                          fontSize: dynamicFontSize(12),
                          color: Colours.DARKLIGHTGRAY,
                          fontFamily: "Sen-Regular",
                        }}
                      >
                        {history?.reference}
                      </Text>
                    </View>
                  </View>
                  {/* <Image source={{ uri: pulls?.image }}
                                                      style={styles.partyImgSmall} /> */}
                </View>
                <View
                  style={{
                    height: 1,
                    backgroundColor: Colours.LIGHTGRAY,
                    marginVertical: dynamicSpacing(5),
                    marginBottom: dynamicSpacing(10),
                  }}
                />
              </TouchableOpacity>
            )}
          />
        </View>
      ) : (
        ""
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  bodyContainer: {
    margin: dynamicSpacing(15),
    marginBottom: 0,
    // marginTop: 10,
    padding: dynamicSpacing(15),
    // width: 400,
    //   height:200,
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
    //   backgroundColor: '#E8E8E8',
    shadowColor: "#E8E8E8",
  },
  giverHeaders: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tablesListContainer2: {
    paddingBottom: dynamicSpacing(10),
    gap: dynamicSpacing(2),
  },
  profileContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: dynamicSpacing(5),
    gap: dynamicSpacing(5),
  },
  profileSubContainer: {
    display: "flex",
    // flexDirection: 'row',
    // alignItems: 'center',
    gap: dynamicSpacing(5),
  },
  tableListTitlesContain: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    // padding: 20,
    // backgroundColor:'blue',
    // width: 330,
    gap: dynamicSpacing(2),
  },
  pullValueContainer: {
    display: "flex",
    flexDirection: "row",
    // justifyContent: 'space-between',
    alignItems: "center",
    gap: dynamicSpacing(10),
    width: dynamicSize(130),
  },
  tableValueContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: dynamicSize(130),
  },
});

export default MeezaCreditTransactionHistory;
